import { Grid, Stack, Typography } from "@mui/material";
import FormatSelect from "../../FormatSelect";

import type { NumberFormatterOptions } from "../../../../../../../../../api/types/fieldConfigurationTypes.ts";
import type { CurrencyDimensionMeta } from "../../../../../../../../../api/types/svTypes.ts";

interface Props {
  Label: React.ReactNode;
  format: NumberFormatterOptions | undefined | null;
  onUpdateFormatter: (formatter: NumberFormatterOptions | undefined) => void;
  readonlyMode: boolean;
  currencyDimensions?: CurrencyDimensionMeta[];
}

const FormatSettings = ({ Label, format, onUpdateFormatter, readonlyMode, currencyDimensions }: Props) => {
  return (
    <Stack
      useFlexGap
      sx={{
        flex: 1,
        borderBottom: "1px dashed",
        borderBottomColor: "divider",
        gap: ".5rem",
        pb: "1rem",
      }}
    >
      {Label}
      <Grid container sx={{ alignItems: "center" }}>
        <Typography sx={(theme) => ({ color: theme.palette.text.secondary, width: "5rem" })}>Format</Typography>
        <FormatSelect
          format={format}
          currencyDimensions={currencyDimensions}
          onUpdateFormatter={onUpdateFormatter}
          disabled={readonlyMode}
        />
      </Grid>
    </Stack>
  );
};

export default FormatSettings;
